// SmartVibes Subscription Addon Script - with redeclaration protection
(function() {
  'use strict';

  function initializeAddon() {
    console.log('🚀 Initializing addon system...');
    const addonBlock = document.querySelector('[data-addon-block]');

    if (!addonBlock) {
      console.log('❌ No addon block found. Checking for addon blocks in DOM...');
      const allAddonElements = document.querySelectorAll('[id*="addon"], [class*="addon"], [data*="addon"]');
      console.log('🔍 Found elements with "addon" in attributes:', allAddonElements);

      // Check if there are any addon-related sections
      const addonBlocks = document.querySelectorAll('[data-addon-block], [id^="addon-block"]');
      console.log('🔍 Addon blocks found:', addonBlocks.length);

      if (addonBlocks.length === 0) {
        console.log('⚠️ No addon blocks configured. The addon block may be:');
        console.log('   1. Not enabled in theme customizer');
        console.log('   2. Set to target a different product');
        console.log('   3. Missing required settings (variant ID, selling plan ID)');
      }

      return;
    }

    console.log('✅ Addon block found:', addonBlock);

    const config = {
      variantId: addonBlock.dataset.addonVariantId,
      sellingPlanId: addonBlock.dataset.addonSellingPlanId,
      name: addonBlock.dataset.addonName || 'Product Add-on',
      enabled: addonBlock.dataset.addonEnabled === 'true',
      separateLineItems: addonBlock.dataset.separateLineItems === 'true',
      showCheckbox: addonBlock.dataset.showCheckbox !== 'false', // Default to true if not specified
      backgroundColor: addonBlock.dataset.backgroundColor || '#f8f8f8',
      checkboxColor: addonBlock.dataset.checkboxColor || '#007cba',
      descriptionChecked: addonBlock.dataset.descriptionChecked || '',
      descriptionUnchecked: addonBlock.dataset.descriptionUnchecked || '',
      nameFontSizeDesktop: addonBlock.dataset.addonNameFontSizeDesktop || '1.0',
      nameFontSizeMobile: addonBlock.dataset.addonNameFontSizeMobile || '0.9',
      descriptionFontSizeDesktop: addonBlock.dataset.addonDescriptionFontSizeDesktop || '0.9',
      descriptionFontSizeMobile: addonBlock.dataset.addonDescriptionFontSizeMobile || '0.8',
      checkboxSize: addonBlock.dataset.checkboxSize || '1.3',
      nameShowBorder: addonBlock.dataset.addonNameShowBorder === 'true',
      nameBorderWidth: addonBlock.dataset.addonNameBorderWidth || '1',
      nameBorderColor: addonBlock.dataset.addonNameBorderColor || '#cccccc',
      namePaddingVertical: addonBlock.dataset.addonNamePaddingVertical || '4',
      namePaddingHorizontal: addonBlock.dataset.addonNamePaddingHorizontal || '8',
      addonTitleText: addonBlock.dataset.addonTitleText || '',
      addonTitleStyle: addonBlock.dataset.addonTitleStyle || 'normal',
      addonTitleColor: addonBlock.dataset.addonTitleColor || '',
      enableAddonTitle: addonBlock.dataset.enableAddonTitle === 'true',
      addonPriceText: addonBlock.dataset.addonPriceText || '',
      addonPrice: 0, // Will be fetched from product API

      // Badge overlay configuration
      enableBadge: addonBlock.dataset.enableBadge !== 'false', // Default to true
      badgeImageUrl: addonBlock.dataset.badgeImageUrl || '',
      badgePositionX: addonBlock.dataset.badgePositionX || '85', // percentage from left edge (0-100)
      badgePositionY: addonBlock.dataset.badgePositionY || '15', // percentage from top edge (0-100)
      badgeSize: addonBlock.dataset.badgeSize || '80', // size in pixels
      badgeSizeMobile: addonBlock.dataset.badgeSizeMobile || '50', // mobile size in pixels
      badgeOpacity: addonBlock.dataset.badgeOpacity || '0.9',
      badgeAltText: addonBlock.dataset.badgeAltText || 'Add-on Included'
    };

    console.log('📋 Addon configuration:', {
      enabled: config.enabled,
      showCheckbox: config.showCheckbox,
      variantId: config.variantId,
      sellingPlanId: config.sellingPlanId,
      name: config.name
    });

    if (!config.enabled) {
      console.log('❌ Addon is not enabled (config.enabled = false)');
      return;
    }

    if (!config.variantId) {
      console.log('❌ Missing addon variant ID');
      return;
    }

    if (!config.sellingPlanId) {
      console.log('❌ Missing addon selling plan ID');
      return;
    }

    console.log('✅ All required addon settings are present, proceeding with initialization...');

    // Check if addon is already initialized to prevent duplicates
    if (document.getElementById('addon-container') && window.addonInitialized !== false) {
      return;
    }

    // Mark as initialized
    window.addonInitialized = true;

    // Fetch addon product price
    const fetchAddonPrice = async () => {
      try {
        const response = await fetch(`/products.json`);
        const data = await response.json();

        // Find the product containing our variant
        for (const product of data.products) {
          const variant = product.variants.find(v => v.id.toString() === config.variantId);
          if (variant) {
            config.addonPrice = parseFloat(variant.price);
            console.log('Addon price fetched:', config.addonPrice);
            return config.addonPrice;
          }
        }

        // Fallback: try direct variant fetch
        const variantResponse = await fetch(`/variants/${config.variantId}.js`);
        if (variantResponse.ok) {
          const variantData = await variantResponse.json();
          config.addonPrice = parseFloat(variantData.price) / 100; // Shopify returns price in cents
          console.log('Addon price fetched (fallback):', config.addonPrice);
          return config.addonPrice;
        }

      } catch (error) {
        console.error('Error fetching addon price:', error);
        config.addonPrice = 99.00; // Fallback price
      }
      return config.addonPrice;
    };

    setTimeout(async function() {
      // Fetch the addon price first
      console.log('Fetching addon price...');
      await fetchAddonPrice();
      console.log('Addon price fetch completed. Price is:', config.addonPrice);
      const form = document.querySelector('form[action="/cart/add"]') ||
                   document.querySelector('.product-form form') ||
                   document.querySelector('#product-form');

      if (!form) return;

      // Create checkbox with custom styling
      const getUncheckedDescriptionHTML = (desc) => {
        // Check if it's HTML content
        if (desc.includes('<')) {
          // For HTML content, look for pattern within text content
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = desc;
          const textContent = tempDiv.textContent || tempDiv.innerText || '';

          // Match up to and including the first dash (hyphen or em dash)
          const match = textContent.match(/^(.*?[—-])(.*)$/);
          if (match) {
            const firstPart = match[1].trim();
            const rest = match[2].trim();
            // Replace the first part in the HTML with styled version
            const styledFirstPart = `<span style="color: red;">${firstPart}</span>`;
            return desc.replace(firstPart, styledFirstPart);
          } else {
            return desc;
          }
        } else {
          // For plain text, match up to and including the first dash
          const match = desc.match(/^(.*?[—-])(.*)$/);
          if (match) {
            const firstPart = match[1].trim();
            const rest = match[2].trim();
            return `<span style="color: red;">${firstPart}</span> ${rest}`;
          } else {
            return desc;
          }
        }
      };

      // Generate the addon HTML based on showCheckbox setting
      const addonHTML = config.showCheckbox ? `
        <style>
          #addon-description p { margin: 0.5em 0; }
          #addon-description p:first-child { margin-top: 0; }
          #addon-description p:last-child { margin-bottom: 0; }
          #addon-description strong { font-weight: bold; }
          #addon-description em { font-style: italic; }
          #addon-description ul, #addon-description ol { margin: 0.5em 0; padding-left: 1.5em; }
          #addon-description li { margin: 0.25em 0; }
          #addon-description span[style*="color: red"] { color: red !important; }
          #addon-name p { margin: 0; display: inline; }
          #addon-name strong { font-weight: bold; }
          #addon-name em { font-style: italic; }
          .addon-price-crossed {
            text-decoration: line-through;
            text-decoration-color: red;
            text-decoration-thickness: 2px;
            color: #999;
            margin-right: 8px;
            position: relative;
          }
          .addon-price-crossed::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(to top right, transparent 45%, red 45%, red 55%, transparent 55%);
            pointer-events: none;
          }
          .addon-price-current {
            font-weight: bold;
            color: #007cba;
          }
          .wearable-pricing-container {
            background: white;
            text-align: left;
            max-width: 100%;
          }
          .wearable-pricing-flex {
            display: flex;
            align-items: baseline;
            justify-content: flex-start;
            gap: 4px;
          }
          .wearable-price {
            font-size: 22px;
            color: #000000;
            margin: 0;
            line-height: 1;
            position: relative;
            display: inline-block;
            font-weight: 500 !important;
            padding-top: 2px;
            margin-right: 15px;
          }

          /* Responsive adjustments for mobile - stack vertically */
          @media screen and (max-width: 600px) {
            .wearable-pricing-container {
              max-width: 100% !important;
              width: 100% !important;
              overflow: visible !important;
              box-sizing: border-box !important;
            }
            .wearable-pricing-flex {
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 1px !important;
              width: 100% !important;
            }
            .wearable-price {
              font-size: 16px !important;
              margin-right: 0 !important;
              margin-bottom: 1px !important;
              padding-top: 1px !important;
              max-width: 100% !important;
              word-wrap: break-word !important;
            }
          }

          @media screen and (max-width: 400px) {
            .wearable-price {
              font-size: 14px !important;
            }
          }
          .wearable-price::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 70%;
            background: linear-gradient(to top left, transparent 45%, #ff0000 47%, #ff0000 53%, transparent 55%);
            pointer-events: none;
          }
          .wearable-condition {
            font-size: 0.8em;
            color: #666;
          }
          #addon-checkbox-label {
            padding: ${config.namePaddingVertical}px ${config.namePaddingHorizontal}px !important;
            display: flex !important;
            align-items: flex-start !important;
            cursor: pointer !important;
            margin-bottom: 10px !important;
          }
          #addon-container {
            ${config.nameShowBorder ? `border: ${config.nameBorderWidth}px solid ${config.nameBorderColor} !important;` : ''}
            ${config.nameShowBorder ? 'border-radius: 5px !important;' : ''}
          }
          @media screen and (min-width: 750px) {
            #addon-name { font-size: ${config.nameFontSizeDesktop}rem !important; }
            #addon-description { font-size: ${config.descriptionFontSizeDesktop}rem !important; }
            #addon-checkbox { transform: scale(${parseFloat(config.checkboxSize) * 1.2}) !important; }
          }
          @media screen and (max-width: 749px) {
            #addon-checkbox { transform: scale(${parseFloat(config.checkboxSize) * 1.2}) !important; }
            #addon-checkbox-label { padding: 12px !important; }
            #addon-name { font-size: ${config.nameFontSizeMobile}rem !important; }
            #addon-description { font-size: ${config.descriptionFontSizeMobile}rem !important; }
          }
        </style>
        <div id="addon-container" style="margin: 10px 0; padding: 5px 15px 5px 0; background: ${config.backgroundColor}; border-radius: 5px;">
          <label id="addon-checkbox-label">
            <input type="checkbox" id="addon-checkbox" checked
                   style="margin-right: 15px; accent-color: ${config.checkboxColor};">
            <span id="addon-name"><!-- Name will be populated by JavaScript --></span>
          </label>
          <div id="addon-description" style="color: black; margin-top: 5px; padding: 0 ${config.namePaddingHorizontal}px 5px ${config.namePaddingHorizontal}px; line-height: 1.5;">
            <!-- Description will be populated by JavaScript -->
          </div>
        </div>
      ` : `
        <style>
          #addon-description p { margin: 0.5em 0; }
          #addon-description p:first-child { margin-top: 0; }
          #addon-description p:last-child { margin-bottom: 0; }
          #addon-description strong { font-weight: bold; }
          #addon-description em { font-style: italic; }
          #addon-description ul, #addon-description ol { margin: 0.5em 0; padding-left: 1.5em; }
          #addon-description li { margin: 0.25em 0; }
          #addon-name p { margin: 0; display: inline; }
          #addon-name strong { font-weight: bold; }
          #addon-name em { font-style: italic; }
          #addon-info-label {
            padding: ${config.namePaddingVertical}px ${config.namePaddingHorizontal}px !important;
            display: flex !important;
            align-items: flex-start !important;
            margin-bottom: 10px !important;
          }
          #addon-container {
            ${config.nameShowBorder ? `border: ${config.nameBorderWidth}px solid ${config.nameBorderColor} !important;` : ''}
            ${config.nameShowBorder ? 'border-radius: 5px !important;' : ''}
          }
          @media screen and (min-width: 750px) {
            #addon-name { font-size: ${config.nameFontSizeDesktop}rem !important; }
            #addon-description { font-size: ${config.descriptionFontSizeDesktop}rem !important; }
          }
          @media screen and (max-width: 749px) {
            #addon-info-label { padding: 12px !important; }
            #addon-name { font-size: ${config.nameFontSizeMobile}rem !important; }
            #addon-description { font-size: ${config.descriptionFontSizeMobile}rem !important; }
          }
        </style>
        <div id="addon-container" style="margin: 10px 0; padding: 5px 15px 5px 0; background: ${config.backgroundColor}; border-radius: 5px;">
          <div id="addon-info-label">
            <!-- Hidden checkbox for consistency with existing logic -->
            <input type="checkbox" id="addon-checkbox" checked style="display: none;">
            <span id="addon-name"><!-- Name will be populated by JavaScript --></span>
          </div>
          <div id="addon-description" style="color: black; margin-top: 5px; padding: 0 ${config.namePaddingHorizontal}px 5px ${config.namePaddingHorizontal}px; line-height: 1.5;">
            <!-- Description will be populated by JavaScript -->
          </div>
        </div>
      `;

          // Keep the addon exactly where you placed it in the section blocks
      const existingContainer = document.getElementById('addon-container');
      if (!existingContainer || window.addonInitialized === false) {
        addonBlock.innerHTML = addonHTML;
      } else {
        return; // Don't recreate DOM or set up duplicate event listeners
      }

      const checkbox = document.getElementById('addon-checkbox');
      const description = document.getElementById('addon-description');
      const addonNameSpan = document.getElementById('addon-name');
      const addToCartBtn = document.querySelector('button[type="submit"][name="add"]') ||
                          document.querySelector('button[type="submit"]') ||
                          document.querySelector('.product-form__cart-submit');

      // Set the addon name with richtext support
      if (addonNameSpan) {
        addonNameSpan.innerHTML = config.name;
      }

      // Find the main product title element
      const productTitleElement = document.querySelector('h1.product__heading') ||
                                  document.querySelector('.product__heading') ||
                                  document.querySelector('.product__title h1') ||
                                  document.querySelector('.product__title [class*="product__heading"]');

      // Store the original product title (ensure we get the true original)
      let originalProductTitle = '';
      if (productTitleElement) {
        // Check if we've already stored the original title globally
        if (!window.addonOriginalProductTitle) {
          // First time - store the truly original title
          window.addonOriginalProductTitle = productTitleElement.textContent.trim();
          console.log('💾 Stored original product title for first time:', window.addonOriginalProductTitle);
        }
        originalProductTitle = window.addonOriginalProductTitle;
        console.log('✅ Found product title element:', productTitleElement);
        console.log('📝 Using original product title:', originalProductTitle);
      } else {
        console.log('⚠️ Product title element not found - conditional title will not work');
      }

      // Function to update conditional title display
      const updateTitleDisplay = (isChecked) => {
        if (!productTitleElement || !config.enableAddonTitle || !config.addonTitleText) {
          console.log('🔄 Title update skipped:', {
            hasProductTitle: !!productTitleElement,
            titleEnabled: config.enableAddonTitle,
            hasText: !!config.addonTitleText
          });
          return; // No product title element, feature disabled, or no title text
        }

        console.log('🔄 Updating product title:', {
          isChecked,
          originalTitle: originalProductTitle,
          addonText: config.addonTitleText
        });

        if (isChecked) {
          // Add the conditional title to the main product title
          const newTitle = originalProductTitle + ' ' + config.addonTitleText;

          // Apply styling to the addon part if specified
          if (config.addonTitleStyle !== 'normal' || config.addonTitleColor) {
            // Wrap the addon text in a span for styling
            const styledAddonText = `<span class="addon-title-part" style="${getAddonTitleStyles()}">${config.addonTitleText}</span>`;
            productTitleElement.innerHTML = originalProductTitle + ' ' + styledAddonText;
            console.log('✅ Product title updated with styling:', originalProductTitle + ' ' + config.addonTitleText);
          } else {
            productTitleElement.innerHTML = newTitle;
            console.log('✅ Product title updated (no styling):', newTitle);
          }
        } else {
          // Restore the original title when unchecked
          productTitleElement.innerHTML = originalProductTitle;
          console.log('✅ Product title restored to original:', originalProductTitle);
        }
      };

      // Helper function to get addon title styles
      const getAddonTitleStyles = () => {
        let styles = [];

        switch (config.addonTitleStyle) {
          case 'bold':
            styles.push('font-weight: bold');
            break;
          case 'italic':
            styles.push('font-style: italic');
            break;
          case 'bold_italic':
            styles.push('font-weight: bold', 'font-style: italic');
            break;
        }

        if (config.addonTitleColor) {
          styles.push(`color: ${config.addonTitleColor}`);
        }

        return styles.join('; ');
      };

      // Restore checkbox state from localStorage (for featured product persistence)
      const savedCheckboxState = localStorage.getItem('addon-checkbox-state');
      if (savedCheckboxState !== null && checkbox) {
        checkbox.checked = savedCheckboxState === 'true';
      }

      if (!addToCartBtn) return;

      // Price update functions removed - feature disabled

      // Track current badge
      let currentBadge = null;
      let lastBadgeContainer = null;
      let badgeRemovalInProgress = false;

      // Function to calculate badge styles (moved up for accessibility)
      const calculateBadgeStyles = () => {
        // Use device-specific badge size
        const isMobile = window.innerWidth <= 749;
        let badgeSize = isMobile ? parseInt(config.badgeSizeMobile) : parseInt(config.badgeSize);

        // Ensure minimum size for visibility
        if (isMobile && badgeSize < 25) {
          badgeSize = 25;
        } else if (!isMobile && badgeSize < 50) {
          badgeSize = 50;
        }

        // Use percentage-based positioning for precise control
        const positionX = config.badgePositionX + '%';
        const positionY = config.badgePositionY + '%';
        const positionStyles = `
          left: ${positionX} !important;
          top: ${positionY} !important;
          transform: translate(-50%, -50%) !important;
        `;

        // Return complete style string
        return `
          position: absolute !important;
          ${positionStyles}
          width: ${badgeSize}px !important;
          height: ${badgeSize}px !important;
          z-index: 20 !important;
          pointer-events: none !important;
          transition: opacity 0.3s ease !important;
          border-radius: 0 !important;
          background: none !important;
          background-color: transparent !important;
          border: none !important;
          box-shadow: none !important;
          object-fit: contain !important;
        `;
      };

      // Function to create new badge (moved up for accessibility)
      const createNewBadge = (imageContainer) => {
        if (!imageContainer) return;

        // Safety check: Don't create badge if badge feature is disabled
        if (!config.enableBadge) {
          console.log('🚫 Badge creation skipped - badge overlay disabled in settings');
          return;
        }

        // Safety check: Don't create badge if removal is in progress
        if (badgeRemovalInProgress) return;

        // Safety check: Don't create badge if checkbox is unchecked
        if (!checkbox.checked) return;

        // CRITICAL: Remove any existing badges from this container to prevent duplicates
        const existingBadges = imageContainer.querySelectorAll('.addon-badge, .smartvibes-badge');
        existingBadges.forEach(badge => badge.remove());

        // Also clean up the global currentBadge if it's in a different container
        if (currentBadge && currentBadge.parentNode && currentBadge.parentNode !== imageContainer) {
          currentBadge.remove();
          currentBadge = null;
          lastBadgeContainer = null;
        }

        // Double-check: If we already have a badge in this exact container, don't create another
        if (currentBadge && currentBadge.parentNode === imageContainer) {
          return;
        }

        const badge = document.createElement('img');
        badge.src = config.badgeImageUrl;
        badge.className = 'addon-badge smartvibes-badge'; // Keep both classes for compatibility
        badge.alt = config.badgeAltText;

        // Add data attribute to track creation
        badge.setAttribute('data-creation-time', Date.now());
        badge.setAttribute('data-checkbox-state', checkbox.checked);
        badge.setAttribute('data-container-id', imageContainer.id || 'no-id');

        // Calculate size and styles
        const styles = calculateBadgeStyles();
        badge.style.cssText = styles;

        // Start with 0 opacity for smooth fade in
        badge.style.opacity = '0';

        // Ensure the container can hold positioned elements
        const currentPosition = window.getComputedStyle(imageContainer).position;
        if (currentPosition === 'static') {
          imageContainer.style.position = 'relative';
        }

        imageContainer.appendChild(badge);
        currentBadge = badge;
        lastBadgeContainer = imageContainer;

        // Wait for badge image to load before fading in
        badge.onload = () => {
          if (badge && badge.parentNode) {
            setTimeout(() => {
              badge.style.opacity = config.badgeOpacity;
            }, 20);
          }
        };

        // Fallback fade in if image loads too quickly
        setTimeout(() => {
          if (badge && badge.parentNode && badge.style.opacity === '0') {
            badge.style.opacity = config.badgeOpacity;
          }
        }, 100);
      };

      // Function to find the currently active/visible product image (SCOPED TO FEATURED PRODUCT)
      const findActiveImage = () => {

        // Find the specific featured product section that contains our addon
        const featuredProductSection = addonBlock.closest('[data-section]') ||
                                      addonBlock.closest('.featured-product') ||
                                      addonBlock.closest('.product') ||
                                      document.querySelector('.featured-product');

        if (!featuredProductSection) {
          return null;
        }

        // First, try to find explicitly active elements within the featured product section only
        const activeSelectors = [
          '.product__media-gallery .product__media-item.is-active .media',
          '.product__media-list .slider__slide.is-active .media',
          '.product-gallery .product__media-item.is-active .media',
          '.product__media-gallery .product__media-item.is-active',
          '.product__media-list .slider__slide.is-active',
          '.product-gallery .product__media-item.is-active',
          '.slideshow .slideshow__slide.is-active .media',
          '.slideshow .slideshow__slide.is-active',
          '.slider .slider__slide.is-active .media',
          '.slider .slider__slide.is-active',
          '.product-slideshow .slide.is-active .media',
          '.product-slideshow .slide.is-active',
          '.product__media .media[aria-current="true"]',
          '.product__media [aria-current="true"] .media',
          '.product__media .current .media',
          '.product__media .current'
        ];

        for (const selector of activeSelectors) {
          const element = featuredProductSection.querySelector(selector);
          if (element) {
            const style = window.getComputedStyle(element);
            if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
              return element;
            }
          }
        }

        // If no active element found, look for currently visible images within featured product
        const visibleSelectors = [
          '.product__media-gallery .product__media-item:not([hidden]):not(.hide) .media',
          '.product__media-list .slider__slide:not([hidden]):not(.hide) .media',
          '.product__media-gallery .product__media-item:not([hidden]):not(.hide)',
          '.product__media-list .slider__slide:not([hidden]):not(.hide)',
          '.slideshow .slideshow__slide:not([hidden]):not(.hide) .media',
          '.slideshow .slideshow__slide:not([hidden]):not(.hide)',
          '.slider .slider__slide:not([hidden]):not(.hide) .media',
          '.slider .slider__slide:not([hidden]):not(.hide)',
          '.product__media-wrapper .media',
          '[data-media-id] .media',
          '.product__media .media'
        ];

        for (const selector of visibleSelectors) {
          const elements = featuredProductSection.querySelectorAll(selector);
          for (const element of elements) {
            const style = window.getComputedStyle(element);
            const rect = element.getBoundingClientRect();
            // Check if element is visible and has dimensions and is in viewport
            if (style.display !== 'none' &&
                style.visibility !== 'hidden' &&
                parseFloat(style.opacity) > 0.1 &&
                rect.width > 0 && rect.height > 0 &&
                rect.top < window.innerHeight && rect.bottom > 0) {
              return element;
            }
          }
        }

        // Advanced: Look for images by transform/position within featured product
        const transformSelectors = [
          '.product__media .media',
          '.slideshow .media',
          '.slider .media'
        ];

        for (const selector of transformSelectors) {
          const elements = featuredProductSection.querySelectorAll(selector);
          for (const element of elements) {
            const style = window.getComputedStyle(element);
            const rect = element.getBoundingClientRect();
            const transform = style.transform;

            // Check if element is positioned in the center/visible area
            if (style.display !== 'none' &&
                parseFloat(style.opacity) > 0.1 &&
                rect.width > 0 && rect.height > 0) {

              // For transform-based sliders, check if element is roughly centered
              const centerX = rect.left + rect.width / 2;
              const centerY = rect.top + rect.height / 2;
              const viewportCenterX = window.innerWidth / 2;
              const viewportCenterY = window.innerHeight / 2;

              // If element center is reasonably close to viewport center
              if (Math.abs(centerX - viewportCenterX) < window.innerWidth * 0.4 &&
                  centerY > 0 && centerY < window.innerHeight) {
                return element;
              }
            }
          }
        }

        // Last resort: find any image within the featured product section
        const fallbackSelectors = [
          '.product__media img',
          '.product-gallery img',
          'img',
          '.slideshow img',
          '.slider img'
        ];

        for (const selector of fallbackSelectors) {
          const element = featuredProductSection.querySelector(selector);
          if (element) {
            return element.closest('.media') || element.parentElement;
          }
        }

        return null;
      };

      // Function to immediately remove all badges (emergency cleanup) - DEFINED EARLY
      const forceRemoveAllBadges = () => {
        badgeRemovalInProgress = true;

        // Remove tracked badge
        if (currentBadge) {
          if (currentBadge.parentNode) {
            currentBadge.remove();
          }
          currentBadge = null;
          lastBadgeContainer = null;
        }

        // Remove any orphaned badges
        const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
        allBadges.forEach(badge => badge.remove());

        // Clear removal flag after a delay
        setTimeout(() => {
          badgeRemovalInProgress = false;
        }, 300);
      };

      // Function to clean up duplicate badges (silent cleanup)
      const cleanupDuplicateBadges = () => {
        const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
        if (allBadges.length > 1) {
          // Keep the most recent badge (highest data-creation-time)
          let newestBadge = null;
          let newestTime = 0;

          allBadges.forEach(badge => {
            const creationTime = parseInt(badge.getAttribute('data-creation-time') || '0');
            if (creationTime > newestTime) {
              newestTime = creationTime;
              newestBadge = badge;
            }
          });

          // Remove all except the newest
          allBadges.forEach(badge => {
            if (badge !== newestBadge) {
              badge.remove();
            }
          });

          // Update tracking
          currentBadge = newestBadge;
          lastBadgeContainer = newestBadge ? newestBadge.parentNode : null;
        }
      };

      // Simplified badge display function - just recreate the slideshow container badge
      const updateBadgeDisplay = (isChecked, isVariantChange = false) => {

        // CRITICAL: Don't schedule badge creation if removal is in progress
        if (badgeRemovalInProgress && isChecked) {
          return;
        }

        // If badge overlay is disabled, always remove badges
        if (!config.enableBadge) {
          const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
          allBadges.forEach(badge => badge.remove());
          currentBadge = null;
          lastBadgeContainer = null;
          console.log('🚫 Badge display update skipped - badge overlay disabled in settings');
          return;
        }

        // If unchecked, remove all badges
        if (!isChecked) {
          const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
          allBadges.forEach(badge => badge.remove());
          currentBadge = null;
          lastBadgeContainer = null;
          return;
        }

        // If checked, just run the slideshow container system
        slideshowContainerBadgeSystem();
      };

      // Redundant badge functions removed

      // Update description and title when checkbox changes (SIMPLIFIED)
      checkbox.addEventListener('change', function() {
        console.log('✅ Checkbox changed to:', checkbox.checked);

        // Save checkbox state for persistence across featured product reloads
        localStorage.setItem('addon-checkbox-state', checkbox.checked.toString());

        if (checkbox.checked) {
          description.innerHTML = config.descriptionChecked;
          // Update conditional title display
          updateTitleDisplay(true);
          // Create badge on slideshow container
          slideshowContainerBadgeSystem();
        } else {
          // Always use the function to handle red/bold styling for unchecked state
          description.innerHTML = getUncheckedDescriptionHTML(config.descriptionUnchecked || '');

          // Update conditional title display
          updateTitleDisplay(false);

          // Add "Learn More" link after description when unchecked (only if checkbox is visible)
          if (config.showCheckbox) {
            addLearnMoreLink();
          }

          // Remove all badges when unchecked
          const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
          allBadges.forEach(badge => badge.remove());
          currentBadge = null;
          lastBadgeContainer = null;
          console.log('🔴 Checkbox unchecked - removed all badges');
        }
      });

      // Set initial description and title based on checkbox state (after restoration)
      if (checkbox.checked) {
        description.innerHTML = config.descriptionChecked;
        updateTitleDisplay(true);
      } else {
        // Always use the function to handle red/bold styling for unchecked state
        description.innerHTML = getUncheckedDescriptionHTML(config.descriptionUnchecked || '');
        updateTitleDisplay(false);
        // Add "Learn More" link for initial unchecked state (only if checkbox is visible)
        if (config.showCheckbox) {
          addLearnMoreLink();
        }
      }

      // Clean up any orphaned badges on init (only once)
      const orphanedBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
      orphanedBadges.forEach(badge => badge.remove());
      if (orphanedBadges.length > 0) {
        console.log('🧹 Cleaned up', orphanedBadges.length, 'orphaned badges on init');
      }

      // Set up global badge monitoring system
      const globalBadgeMonitor = new MutationObserver(function(mutations) {
        // Only monitor when checkbox is unchecked
        if (checkbox.checked) return;

        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if the added node is a badge
              if (node.classList && (node.classList.contains('addon-badge') || node.classList.contains('smartvibes-badge'))) {
                console.log('🚨 GLOBAL MONITOR: Unexpected badge creation detected while checkbox unchecked!');
                console.log('🗑️ Removing unauthorized badge immediately:', {
                  src: node.src,
                  className: node.className,
                  parent: node.parentElement?.tagName
                });
                node.remove();
              }

              // Check if any child elements are badges
              const childBadges = node.querySelectorAll && node.querySelectorAll('.addon-badge, .smartvibes-badge');
              if (childBadges && childBadges.length > 0) {
                console.log('🚨 GLOBAL MONITOR: Found', childBadges.length, 'child badges while checkbox unchecked!');
                childBadges.forEach(badge => {
                  console.log('🗑️ Removing child badge:', badge.src);
                  badge.remove();
                });
              }
            }
          });
        });
      });

      // Monitor the entire page for badge creation
      globalBadgeMonitor.observe(document.body, {
        childList: true,
        subtree: true
      });

      console.log('👁️ Global badge monitor activated');

      // Create global debugging function for manual testing
      window.debugBadgeState = function() {
        console.log('🔍 BADGE DEBUG STATE:');
        console.log('- Checkbox checked:', checkbox.checked);
        console.log('- Badge removal in progress:', badgeRemovalInProgress);
        console.log('- Current badge exists:', !!currentBadge);
        console.log('- Current badge element:', currentBadge);
        console.log('- Badge config enabled:', config.enableBadge);
        console.log('- Badge image URL:', config.badgeImageUrl);

        const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
        console.log('- Total badges on page:', allBadges.length);
        allBadges.forEach((badge, index) => {
          console.log(`  Badge ${index + 1}:`, {
            src: badge.src,
            parent: badge.parentElement?.tagName,
            creationTime: badge.getAttribute('data-creation-time'),
            checkboxState: badge.getAttribute('data-checkbox-state')
          });
        });
      };

      // Create global force removal function for manual testing
      window.forceRemoveBadges = function() {
        console.log('🚨 MANUAL FORCE REMOVAL TRIGGERED');
        badgeRemovalInProgress = true;
        forceRemoveAllBadges();

        // Also use nuclear approach
        setTimeout(() => {
          const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
          console.log('🧹 Nuclear cleanup found', allBadges.length, 'badges');
          allBadges.forEach(badge => badge.remove());
        }, 100);
      };

      // Create manual badge update function for testing
      window.testBadgeUpdate = function() {
        console.log('🧪 MANUAL BADGE UPDATE TEST TRIGGERED');
        console.log('Current checkbox state:', checkbox?.checked);

        if (!checkbox?.checked) {
          console.log('❌ Checkbox is unchecked - no badge will be shown');
          return;
        }

        console.log('🔍 Searching for current active image...');
        const activeImage = findActiveImage();
        console.log('Found active image:', activeImage);

        if (activeImage) {
          console.log('✅ Active image found - forcing badge update');
          updateBadgeDisplay(true, false);

          // Multiple retries
          setTimeout(() => updateBadgeDisplay(true, false), 100);
          setTimeout(() => updateBadgeDisplay(true, false), 300);
          setTimeout(() => updateBadgeDisplay(true, false), 500);
        } else {
          console.log('❌ No active image found via findActiveImage()');

          // Find the specific featured product section for debugging
          const featuredProductSection = addonBlock.closest('[data-section]') ||
                                        addonBlock.closest('.featured-product') ||
                                        addonBlock.closest('.product') ||
                                        document.querySelector('.featured-product');

          if (!featuredProductSection) {
            console.log('❌ Could not find featured product section');
            return;
          }

          // Try to find all media elements within the featured product section for debugging
          console.log('🔍 Debugging - media elements found within featured product section:');
          const allMedia = featuredProductSection.querySelectorAll('img, .media img, .product__media img, .slideshow img, .slider img');
          allMedia.forEach((media, index) => {
            const style = window.getComputedStyle(media);
            const rect = media.getBoundingClientRect();
            console.log(`Media ${index}:`, {
              element: media,
              src: media.src,
              display: style.display,
              visibility: style.visibility,
              opacity: style.opacity,
              width: rect.width,
              height: rect.height,
              classes: media.className,
              inViewport: rect.top < window.innerHeight && rect.bottom > 0
            });
          });

          // Try the brute force method within the scoped section
          console.log('🔍 Trying brute force detection within featured product section...');
          let mostVisibleImage = null;
          let maxVisibility = 0;

          allMedia.forEach(img => {
            const rect = img.getBoundingClientRect();
            const style = window.getComputedStyle(img);

            const isDisplayed = style.display !== 'none';
            const isVisible = style.visibility !== 'hidden';
            const hasOpacity = parseFloat(style.opacity) > 0.1;
            const hasSize = rect.width > 50 && rect.height > 50;
            const inViewport = rect.top < window.innerHeight && rect.bottom > 0;

            if (isDisplayed && isVisible && hasOpacity && hasSize && inViewport) {
              const visibilityScore = rect.width * rect.height * parseFloat(style.opacity);
              if (visibilityScore > maxVisibility) {
                maxVisibility = visibilityScore;
                mostVisibleImage = img;
              }
            }
          });

          if (mostVisibleImage) {
            console.log('✅ SCOPED BRUTE FORCE found most visible image:', mostVisibleImage);
            const imageContainer = mostVisibleImage.closest('.media') ||
                                  mostVisibleImage.parentElement ||
                                  mostVisibleImage;
            console.log('Creating badge on container:', imageContainer);
            createNewBadge(imageContainer);
          } else {
            console.log('❌ Even scoped brute force couldn\'t find a visible image in featured product section');
          }
        }
      };



      // Create container test function
      window.testContainers = function() {
        console.log('🧪 CONTAINER TEST - checking what slideshow containers are available');

        const featuredProductSection = addonBlock.closest('[data-section]') ||
                                      addonBlock.closest('.featured-product') ||
                                      addonBlock.closest('.product') ||
                                      document.querySelector('.featured-product');

        console.log('📍 Featured product section:', featuredProductSection);

        if (!featuredProductSection) {
          console.log('❌ No featured product section found');
          return;
        }

        console.log('🔍 Looking for slideshow containers within section:');

        const containerSelectors = [
          '.product__media-gallery',
          '.product__media',
          '.slideshow',
          '.slider',
          '[class*="media"]',
          '[class*="product"]',
          '[class*="gallery"]',
          '[class*="slide"]'
        ];

        containerSelectors.forEach(selector => {
          const element = featuredProductSection.querySelector(selector);
          console.log(`  ${selector}:`, element);
          if (element) {
            console.log(`    Classes: ${element.className}`);
            console.log(`    Tag: ${element.tagName}`);
            console.log(`    Has images: ${element.querySelectorAll('img').length}`);
          }
        });

        console.log('🖼️ All images in section:');
        const allImages = featuredProductSection.querySelectorAll('img');
        allImages.forEach((img, index) => {
          console.log(`  Image ${index}:`, img.src, img.parentElement);
        });

        console.log('✅ Container test complete');
      };

      // Create force badge test function
      window.forceBadgeTest = function() {
        console.log('🧪 FORCE BADGE TEST - trying to create badge on any available container');

        if (!checkbox.checked) {
          console.log('❌ Checkbox is not checked - checking it now');
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change'));
        }

        const featuredProductSection = addonBlock.closest('[data-section]') ||
                                      addonBlock.closest('.featured-product') ||
                                      addonBlock.closest('.product') ||
                                      document.querySelector('.featured-product');

        if (!featuredProductSection) {
          console.log('❌ No featured product section found');
          return;
        }

               // Try to find ANY suitable container - prioritize slideshow containers
         const possibleContainers = [
           featuredProductSection.querySelector('product-gallery'), // Best: actual slideshow
           featuredProductSection.querySelector('.slider'), // Good: image list
           featuredProductSection.querySelector('.product__media-wrapper'), // Good: wrapper with all images
           featuredProductSection.querySelector('.product__media-gallery'),
           featuredProductSection.querySelector('[class*="media"]'),
           featuredProductSection.querySelector('div'), // Any div
           featuredProductSection // The section itself
         ].filter(el => el !== null);

        console.log('🎯 Found possible containers:', possibleContainers.length);

        if (possibleContainers.length === 0) {
          console.log('❌ No containers found at all');
          return;
        }

        const testContainer = possibleContainers[0];
        console.log('🧪 Testing badge creation on:', testContainer.tagName, testContainer.className);

        // Remove any existing badges
        const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
        allBadges.forEach(badge => badge.remove());

        // Force create badge
        try {
          createNewBadge(testContainer);
          console.log('✅ Badge creation attempted');

          // Check if it worked
          setTimeout(() => {
            const newBadge = document.querySelector('.addon-badge, .smartvibes-badge');
            if (newBadge) {
              console.log('✅ Badge successfully created:', newBadge);
              console.log('Badge parent:', newBadge.parentElement);
              console.log('Badge styles:', newBadge.style.cssText);
            } else {
              console.log('❌ Badge creation failed - no badge found in DOM');
            }
          }, 100);

        } catch (error) {
          console.log('❌ Badge creation error:', error);
        }
      };

      // Define slideshowContainerBadgeSystem function BEFORE it's called
      const slideshowContainerBadgeSystem = () => {
        if (!checkbox.checked) return;

        // Check if badge overlay is disabled
        if (!config.enableBadge) {
          console.log('🚫 Badge system skipped - badge overlay disabled in settings');
          return;
        }

        // Find the specific featured product section that contains our addon
        const featuredProductSection = addonBlock.closest('[data-section]') ||
                                      addonBlock.closest('.featured-product') ||
                                      addonBlock.closest('.product') ||
                                      document.querySelector('.featured-product');

        if (!featuredProductSection) {
          console.log('⚠️ Could not find featured product section');
          return;
        }

        // Find the main slideshow container within the featured product section
        // Based on your structure, prioritize the product-gallery or slider with multiple images
        const slideshowContainer = featuredProductSection.querySelector('product-gallery') ||
                                  featuredProductSection.querySelector('.slider') ||
                                  featuredProductSection.querySelector('.product__media-wrapper') ||
                                  featuredProductSection.querySelector('.product__media-gallery') ||
                                  featuredProductSection.querySelector('[class*="media"]');

        if (!slideshowContainer) {
          console.log('⚠️ Could not find slideshow container');
          return;
        }

        // NEW: Check if we already have a badge that just needs repositioning
        if (currentBadge && currentBadge.parentNode) {
          // If badge is in the correct container, just ensure it's visible
          if (currentBadge.parentNode === slideshowContainer) {
            // Badge is already in correct place - just ensure visibility
            currentBadge.style.opacity = config.badgeOpacity;
            return;
          }

          // Badge is in wrong container - move it instead of recreating
          console.log('🔄 Moving existing badge to new container (no flash)');
          slideshowContainer.appendChild(currentBadge);
          lastBadgeContainer = slideshowContainer;

          // Ensure the new container can hold positioned elements
          const currentPosition = window.getComputedStyle(slideshowContainer).position;
          if (currentPosition === 'static') {
            slideshowContainer.style.position = 'relative';
          }

          // Keep badge visible during move
          currentBadge.style.opacity = config.badgeOpacity;
          return;
        }

        // Only create new badge if none exists
        createNewBadge(slideshowContainer);
      };

      // Mobile badge size test function
      window.testMobileBadge = function() {
        console.log('📱 MOBILE BADGE TEST');
        console.log(`Desktop badge size: ${config.badgeSize}px`);
        console.log(`Mobile badge size: ${config.badgeSizeMobile}px`);
        console.log(`Current screen width: ${window.innerWidth}px`);
        console.log(`Is mobile: ${window.innerWidth <= 749}`);

        // Force recreate badge to test current size
        if (checkbox.checked) {
          const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
          allBadges.forEach(badge => badge.remove());
          slideshowContainerBadgeSystem();
          console.log('✅ Badge recreated with current screen size');
        } else {
          console.log('⚠️ Checkbox is not checked - check it first to see the badge');
        }
      };

      // Debug functions available: debugBadgeState(), forceRemoveBadges(), testBadgeUpdate(), testContainers(), forceBadgeTest(), testMobileBadge()

      // Catch-all observer removed - was causing infinite loops

      // Set initial badge display (only if checked and badge enabled) - SIMPLIFIED
      if (checkbox.checked && config.enableBadge) {
        slideshowContainerBadgeSystem();
      } else if (!config.enableBadge) {
        // Remove any existing badges if badge overlay is disabled
        const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
        allBadges.forEach(badge => badge.remove());
        console.log('🧹 Removed existing badges - badge overlay disabled in settings');
      }

      // Force update immediately after DOM is ready
      setTimeout(() => {
        if (checkbox.checked) {
          updateBadgeDisplay(true, false); // Initial load is not a variant change
        } else {
          // Clean up any badges that might have appeared
          const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
          allBadges.forEach(badge => badge.remove());
        }
      }, 50); // Reduced from 1000ms to 50ms for instant appearance

      // Handle variant changes and image gallery changes to move badge to active image
      const updateBadgeOnVariantChange = function() {

        if (checkbox.checked && !badgeRemovalInProgress) {
          updateBadgeDisplay(true, true); // Pass isVariantChange = true
        } else {
          // Force remove any badges that might have been created
          setTimeout(() => {
            const allBadges = document.querySelectorAll('.addon-badge, .smartvibes-badge');
            if (allBadges.length > 0) {
              allBadges.forEach(badge => badge.remove());
            }
          }, 50);
        }
      };

      // Add slideshow-specific event listeners
      const slideshowEvents = [
        'slideshow:change',
        'slideshow:slide-changed',
        'slider:change',
        'slider:slide-changed',
        'slide:change',
        'slide:changed',
        'carousel:change',
        'carousel:slide-changed',
        'media:change',
        'media:changed'
      ];

      slideshowEvents.forEach(eventName => {
        document.addEventListener(eventName, function(e) {
          if (checkbox.checked) {
            updateBadgeOnVariantChange();
          }
        });
      });

      // Listen for multiple variant change events (different themes use different events)
      document.addEventListener('variant:change', updateBadgeOnVariantChange);
      document.addEventListener('variantChange', updateBadgeOnVariantChange);
      document.addEventListener('variant-change', updateBadgeOnVariantChange);

      // Also listen for form changes (variant selections)
      const productForm = document.querySelector('form[action="/cart/add"]') ||
                         document.querySelector('.product-form form') ||
                         document.querySelector('#product-form');

      if (productForm) {
        productForm.addEventListener('change', function(e) {
          if (e.target.name === 'id' || e.target.closest('[data-option-selector]')) {
            console.log('📝 Product form variant selection changed');
            updateBadgeOnVariantChange();
          }
        });
      }

      // Handle manual image gallery clicks and navigation (expanded for slideshows)
      document.addEventListener('click', function(e) {
        const clickedElement = e.target.closest('.product__media-item') ||
                             e.target.closest('.thumbnail-list__item') ||
                             e.target.closest('.product__media-toggle') ||
                             e.target.closest('[data-media-id]') ||
                             e.target.closest('.slider-button') ||
                             e.target.closest('.slideshow-button') ||
                             e.target.closest('.slideshow__button') ||
                             e.target.closest('.slider-control') ||
                             e.target.closest('.slideshow-control') ||
                             e.target.closest('.media') ||
                             e.target.closest('button[name="previous"]') ||
                             e.target.closest('button[name="next"]') ||
                             e.target.closest('[aria-label*="previous"]') ||
                             e.target.closest('[aria-label*="next"]') ||
                             e.target.closest('.icon-caret') ||
                             e.target.closest('[data-slide]');

        if (clickedElement) {
          if (checkbox.checked) {
            // Multiple retries with increasing delays for slideshow transitions
            setTimeout(() => updateBadgeDisplay(true, false), 50);
            setTimeout(() => updateBadgeDisplay(true, false), 150);
            setTimeout(() => updateBadgeDisplay(true, false), 300);
            setTimeout(() => updateBadgeDisplay(true, false), 500);
          }
        }
      });

      // Handle touch/swipe events for mobile image swiping
      document.addEventListener('touchend', function(e) {
        if (e.target.closest('.product__media-gallery') ||
            e.target.closest('.product__media-list') ||
            e.target.closest('[data-media-gallery]')) {
          if (checkbox.checked) {
            setTimeout(() => {
              updateBadgeDisplay(true, false);
            }, 100); // Slightly longer delay for touch events
          }
        }
      });

      // Handle keyboard navigation (arrow keys)
      document.addEventListener('keydown', function(e) {
        if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') &&
            document.activeElement?.closest('.product__media-gallery, .product__media-list, [data-media-gallery]')) {
          if (checkbox.checked) {
            setTimeout(() => {
              updateBadgeDisplay(true, false);
            }, 100);
          }
        }
      });

      // Listen for any image changes via mutation observer (enhanced for slideshows)
      const imageObserver = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        let isLikelyVariantChange = false;

        mutations.forEach(function(mutation) {
          // Check if classes changed on media items (indicating active state change)
          if (mutation.type === 'attributes' &&
              mutation.attributeName === 'class') {

            // Look for various media-related elements (expanded for slideshows)
            const isMediaElement = mutation.target.classList.contains('product__media-item') ||
                                  mutation.target.classList.contains('slider__slide') ||
                                  mutation.target.classList.contains('slideshow__slide') ||
                                  mutation.target.classList.contains('slide') ||
                                  mutation.target.closest('.product__media-gallery') ||
                                  mutation.target.closest('.product__media-list') ||
                                  mutation.target.closest('.slideshow') ||
                                  mutation.target.closest('.slider') ||
                                  mutation.target.closest('.product-slideshow');

            if (isMediaElement) {
              shouldUpdate = true;

              // Check for various active state indicators
              const hasActiveClass = mutation.target.classList.contains('is-active') ||
                                    mutation.target.classList.contains('current') ||
                                    mutation.target.classList.contains('active') ||
                                    mutation.target.hasAttribute('aria-current');

              const hadActiveClass = mutation.oldValue?.includes('is-active') ||
                                    mutation.oldValue?.includes('current') ||
                                    mutation.oldValue?.includes('active');

              if (hasActiveClass || hadActiveClass) {
                isLikelyVariantChange = true;
              }
            }
          }

          // Watch for aria-current changes (common in accessible slideshows)
          if (mutation.type === 'attributes' &&
              mutation.attributeName === 'aria-current' &&
              mutation.target.closest('.product__media, .slideshow, .slider')) {
            shouldUpdate = true;
          }

          // Also watch for style changes that might indicate visibility changes (expanded)
          if (mutation.type === 'attributes' &&
              mutation.attributeName === 'style' &&
              mutation.target.closest('.product__media-gallery, .product__media-list, .slideshow, .slider')) {
            shouldUpdate = true;
          }

          // Watch for transform changes (CSS-based sliders)
          if (mutation.type === 'attributes' &&
              mutation.attributeName === 'style' &&
              mutation.target.style.transform !== '') {
            const hasMedia = mutation.target.querySelector('.media') || mutation.target.closest('.media');
            if (hasMedia) {
              shouldUpdate = true;
            }
          }
        });

        if (shouldUpdate && checkbox.checked) {
          // Multiple attempts with different delays for slideshow transitions
          setTimeout(() => updateBadgeDisplay(true, isLikelyVariantChange), 10);
          setTimeout(() => updateBadgeDisplay(true, isLikelyVariantChange), 50);
          setTimeout(() => updateBadgeDisplay(true, isLikelyVariantChange), 150);
        }
      });

      // Observe the product media gallery for changes
      const mediaGallery = document.querySelector('.product__media-gallery') ||
                          document.querySelector('.product__media-list') ||
                          document.querySelector('[data-media-gallery]');

      if (mediaGallery) {
        imageObserver.observe(mediaGallery, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });
        console.log('👀 Set up media gallery observer for badge updates');
      }

      // Additional observer to watch for new images being loaded
      const imageLoadObserver = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && // Element node
                (node.tagName === 'IMG' || node.querySelector('img'))) {
              shouldUpdate = true;
            }
          });
        });

        if (shouldUpdate && checkbox.checked) {
          console.log('🖼️ New images detected - updating badge position');
          // New images during variant change are likely part of the variant switch
          updateBadgeDisplay(true, variantChangeInProgress);
        }
      });

      // Observe the entire media gallery for new images
      if (mediaGallery) {
        imageLoadObserver.observe(mediaGallery, {
          childList: true,
          subtree: true
        });
        checkbox._imageLoadObserver = imageLoadObserver;
      }

      // Handle window resize for responsive badge sizing
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (checkbox.checked) {
            updateBadgeDisplay(true, false); // Resize is not a variant change
          }
        }, 250);
      });

      // Store observer reference for cleanup
      checkbox._imageObserver = imageObserver;

              // Duplicate function definition removed - function is now defined earlier in the code

      // Simple monitoring system - just ensure badge stays on slideshow container
      const simpleBadgeMonitor = setInterval(() => {
        if (!checkbox.checked) return;

        // Just make sure badge is still there - if not, recreate it
        if (!currentBadge || !currentBadge.parentNode) {
          slideshowContainerBadgeSystem();
        }

        // Clean up any duplicate badges
        cleanupDuplicateBadges();
      }, 2000); // Check every 2 seconds - much less aggressive

      // Store the simple monitor for cleanup
      checkbox._simpleBadgeMonitor = simpleBadgeMonitor;

      // Cleanup function for when element is removed
      const cleanup = function() {
        if (checkbox._imageObserver) {
          checkbox._imageObserver.disconnect();
        }
        if (checkbox._imageLoadObserver) {
          checkbox._imageLoadObserver.disconnect();
        }
        if (checkbox._simpleBadgeMonitor) {
          clearInterval(checkbox._simpleBadgeMonitor);
        }
      };

      // Store cleanup function for potential future use
      checkbox._cleanup = cleanup;

      // Handle add to cart click
      addToCartBtn.addEventListener('click', function(e) {
        console.log('🔍 ADDON SYSTEM: Add to cart clicked', {
          checkboxChecked: checkbox.checked,
          event: e
        });
        
        if (!checkbox.checked) {
          console.log('❌ ADDON SYSTEM: Checkbox not checked, letting normal flow handle it');
          return;
        }

        console.log('✅ ADDON SYSTEM: Taking over add to cart process');
        e.preventDefault();
        e.stopPropagation();

        const formData = new FormData(form);
        const mainVariantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10);

        // Disable button
        addToCartBtn.disabled = true;
        const originalText = addToCartBtn.textContent;
        addToCartBtn.textContent = 'Adding...';

        // Get the mini cart element to use theme's proper cart system
        const miniCart = document.querySelector('mini-cart');
        const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];

        // Deletion behavior is now handled globally via cart settings

        // CRITICAL: Build items array based on separate_line_items setting
        let itemsToAdd = [];
        
        if (config.separateLineItems && quantity > 1) {
          // Create separate paired line items for each quantity
          console.log(`🔗 ADDON SYSTEM: Creating ${quantity} separate paired line items`);
          for (let i = 0; i < quantity; i++) {
            const pairId = `pair_${Date.now()}_${i}_${Math.random().toString(36).substr(2, 9)}`;
            itemsToAdd.push(
              {
                id: parseInt(config.variantId),
                quantity: 1,
                selling_plan: parseInt(config.sellingPlanId) || config.sellingPlanId,
                properties: {
                  '_paired_with': pairId,
                  '_is_smartvibes': 'true'
                }
              },
              {
                id: parseInt(mainVariantId),
                quantity: 1,
                properties: {
                  '_paired_with': pairId,
                  '_is_apollo': 'true'
                }
              }
            );
          }
        } else {
          // Create a single paired line item with the specified quantity
          const pairId = `pair_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          console.log(`🔗 ADDON SYSTEM: Creating paired items with ID: ${pairId}, quantity: ${quantity}`);
          itemsToAdd = [
            {
              id: parseInt(config.variantId),
              quantity: quantity,
              selling_plan: parseInt(config.sellingPlanId) || config.sellingPlanId,
              properties: {
                '_paired_with': pairId,
                '_is_smartvibes': 'true'
              }
            },
            {
              id: parseInt(mainVariantId),
              quantity: quantity,
              properties: {
                '_paired_with': pairId,
                '_is_apollo': 'true'
              }
            }
          ];
        }

        // Add both products to cart using theme's cart system
        fetch(`${window.Shopify?.routes?.cart_add_url || '/cart/add.js'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: itemsToAdd,
            sections: sections,
            sections_url: window.location.pathname
          })
        })
        .then(response => {
          console.log('📥 ADDON SYSTEM: Response received', {
            status: response.status,
            ok: response.ok
          });
          
          if (!response.ok) {
            return response.text().then(errorText => {
              console.error('❌ ADDON SYSTEM: Error response', errorText);
              throw new Error(JSON.parse(errorText).description || 'Cart error');
            });
          }
          return response.json();
        })
        .then(data => {
          console.log('✅ ADDON SYSTEM: Products added successfully', data);
          // Re-enable button
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = originalText;

          // Use theme's cart rendering system if available
          if (miniCart && data.sections) {
            miniCart.renderContents(data);


            // DISABLED: Cart recommendations to eliminate flashing
            // setTimeout(() => {
            //   reinitializeCartRecommendations();
            // }, 500);
          } else {
            // Fallback: update cart count and refresh
          updateCartCount(data.item_count || data.items.length);
          }

          // Trigger cart update events for other systems (like synchronized-products)
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cart: JSON.stringify(data)
            }
          }));

          // Publish to pubsub system if available
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'addon-script',
              cartData: data
            });
          }

          // Open side cart with a slight delay to ensure rendering is complete
          setTimeout(() => {
            // Try multiple methods to open the cart drawer properly

            // Method 1: Try to find and use the cart drawer element directly
            const cartDrawer = document.querySelector('cart-drawer') ||
                              document.querySelector('mini-cart') ||
                              document.querySelector('.cart-drawer');

            if (cartDrawer) {
              // If it has an open method, use it
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else if (typeof cartDrawer.openMenuDrawer === 'function') {
                cartDrawer.openMenuDrawer();
              } else {
                // Try to trigger the cart drawer opening by setting classes or attributes
                cartDrawer.classList.add('is-open', 'active');
                cartDrawer.setAttribute('open', '');

                // Also try to set the body class for overlay
                document.body.classList.add('cart-drawer-open', 'overflow-hidden');
              }

              console.log('Cart drawer opened using direct method');
              setupSideCartCloseListener();
            } else {
              // Method 2: Try clicking the cart icon (fallback)
              const cartIcon = document.querySelector('.header__icon--cart') ||
                               document.querySelector('[data-cart-drawer]') ||
                               document.querySelector('.cart-link');

              if (cartIcon) {
                console.log('Opening cart via icon click');
                cartIcon.click();
                setupSideCartCloseListener();
              } else {
                // Method 3: Try to dispatch a custom event to open cart
                console.log('Trying custom cart open event');
                document.dispatchEvent(new CustomEvent('cart:open'));

                // Method 4: Last resort - redirect to cart page
                setTimeout(() => {
                  console.log('Redirecting to cart page as fallback');
              window.location.href = '/cart';
                }, 1000);
              }
            }
          }, 300);
        })
        .catch(error => {
          console.error('Cart add error:', error);
          alert('Error adding products to cart: ' + error.message);
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = originalText;
        });
      });
    }, 0); // Instant initialization - no delay
  }








  // Update cart count in header
  function updateCartCount(count) {
    const selectors = [
      '.cart-count-bubble',
      '.cart-count',
      '.header__icon--cart .badge',
      '#cart-icon-bubble',
      '[data-cart-count]'
    ];

    selectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) {
        element.textContent = count;
        element.style.display = count > 0 ? 'block' : 'none';
      }
    });
  }

  // Reinitialize cart recommendations after cart updates
  function reinitializeCartRecommendations() {
    // Don't reload cart recommendations if cart has items - let them stay as they are
    const cartItems = document.querySelectorAll('[data-handle]');
    if (cartItems.length > 0) {
      console.log('🛑 Cart has items - not reinitializing "You may also like" to prevent disruption');
      return;
    }

    console.log('Reinitializing cart recommendations (cart is empty)...');

    // Find all cart-recommendations elements that might need reinitialization
    const cartRecommendations = document.querySelectorAll('cart-recommendations');

    cartRecommendations.forEach((element, index) => {
      console.log(`Found cart-recommendations element ${index}:`, element);

      // Check if it has a data-url (needed for fetching recommendations)
      let dataUrl = element.dataset.url;
      if (!dataUrl) {
        console.log(`Cart recommendations element ${index} has no data-url, skipping`);
        return;
      }

      console.log(`Original data-url: ${dataUrl}`);

      // Force refresh the URL by adding a timestamp to prevent caching
      const urlObj = new URL(dataUrl, window.location.origin);
      urlObj.searchParams.set('_t', Date.now());

      // Also try to get the current first product ID from the cart to ensure fresh recommendations
      const firstCartItem = document.querySelector('[data-handle]');
      if (firstCartItem) {
        const firstProductId = firstCartItem.dataset.productId || firstCartItem.querySelector('[data-product-id]')?.dataset.productId;
        if (firstProductId) {
          console.log(`Updating product_id to: ${firstProductId}`);
          urlObj.searchParams.set('product_id', firstProductId);
        }
      }

      dataUrl = urlObj.toString();
      console.log(`Updated data-url: ${dataUrl}`);

      // Update the element's data-url
      element.dataset.url = dataUrl;

      // Always trigger loading for fresh recommendations (don't check hasContent)
      console.log(`Triggering fresh load for cart recommendations element ${index}`);

      // Clear existing content to force reload
      element.innerHTML = '';

      // Create a new intersection observer for this element
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(element);

        console.log(`Loading recommendations from URL: ${dataUrl}`);

        fetch(dataUrl)
          .then(response => {
            console.log('Fetch response status:', response.status);
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return response.text();
          })
          .then(text => {
            console.log('Received recommendations response, length:', text.length);
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('cart-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              console.log('Updating recommendations content, length:', recommendations.innerHTML.length);
              element.innerHTML = recommendations.innerHTML;

              // Scroll the mini-cart drawer to the top after recommendations load
              const miniCartMain = document.querySelector('#main-cart-items');
              if (miniCartMain) {
                miniCartMain.scrollTop -= miniCartMain.scrollHeight;
              }
            } else {
              console.log('No recommendations content found in response');
              // Log the actual response for debugging
              console.log('Response HTML:', text.substring(0, 500));
            }
          })
          .catch(e => {
            console.error('Error loading cart recommendations:', e);
            console.log('Failed URL:', dataUrl);
          });
      }, { rootMargin: '0px 0px 100px 0px' }); // More generous margin

      // Start observing
      observer.observe(element);
      console.log(`Started observing cart recommendations element ${index} with fresh URL`);
    });
  }

  // Refresh page when side cart closes
  function setupSideCartCloseListener() {
    // Wait a moment before setting up close listeners to avoid interference with opening
    setTimeout(() => {
    const closeSelectors = [
      '.cart-drawer__close',
      '.drawer__close',
      '.cart-close',
        '[data-cart-drawer-close]',
        'drawer-close-button'
    ];

    closeSelectors.forEach(selector => {
      const closeBtn = document.querySelector(selector);
      if (closeBtn) {
          console.log('Setting up close listener for:', selector);
        closeBtn.addEventListener('click', function() {
            console.log('Cart close button clicked, refreshing...');
          setTimeout(() => window.location.reload(), 300);
        }, { once: true });
      }
    });

      // Close on overlay click - but be more specific to avoid interfering
      const overlaySelectors = [
        '.cart-drawer-overlay:not(.is-opening)',
        '.drawer-overlay:not(.is-opening)',
        '.mini-cart-overlay'
      ];

    overlaySelectors.forEach(selector => {
      const overlay = document.querySelector(selector);
      if (overlay) {
          console.log('Setting up overlay click listener for:', selector);
          // Add a small delay to avoid immediate triggering
          setTimeout(() => {
            overlay.addEventListener('click', function(e) {
              // Only close if we're not in the middle of opening
              if (!overlay.classList.contains('is-opening')) {
                console.log('Overlay clicked, refreshing...');
          setTimeout(() => window.location.reload(), 300);
              }
        }, { once: true });
          }, 500);
      }
    });

      // Close on ESC key - but only when cart is fully open
      setTimeout(() => {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
            const cartDrawer = document.querySelector('cart-drawer[open], mini-cart[open], .cart-drawer.is-open');
            if (cartDrawer) {
              console.log('Escape key pressed, refreshing...');
          setTimeout(() => window.location.reload(), 300);
        }
      }
    }, { once: true });
      }, 1000);

      // Reduce the fallback refresh time and make it more conditional
      setTimeout(() => {
        // Only refresh if the cart is still open and no user interaction happened
        const cartDrawer = document.querySelector('cart-drawer[open], mini-cart[open], .cart-drawer.is-open');
        if (cartDrawer) {
          console.log('Fallback refresh after 15 seconds');
          window.location.reload();
        }
      }, 15000);
    }, 1000);
  }





  // Smooth persistence system with debouncing to prevent reloading effect
  function setupAddonPersistence() {
    // Prevent multiple persistence setups
    if (window.addonPersistenceActive) {
      console.log('⚠️ Addon persistence already active - skipping setup');
      return;
    }

    const addonBlock = document.querySelector('[data-addon-block]');
    if (!addonBlock) {
      console.log('❌ No addon block found for persistence');
      return;
    }

    // Store the addon HTML for restoration
    const addonContainer = document.getElementById('addon-container');
    if (!addonContainer) {
      console.log('❌ No addon container found for persistence');
      return;
    }

    // Mark persistence as active
    window.addonPersistenceActive = true;

    const addonHTML = addonBlock.innerHTML; // Store the full addon block content
    console.log('📦 Stored addon HTML for persistence restoration');

    let restoreTimeout = null;
    let isRestoring = false;

    // Debounced restore function to prevent rapid reinitialization
    const debouncedRestore = () => {
      if (isRestoring) return;

      // Clear any existing restore timeout
      if (restoreTimeout) {
        clearTimeout(restoreTimeout);
      }

      // Immediate restoration for featured product sections - much faster
      restoreTimeout = setTimeout(() => {
        const currentAddonBlock = document.querySelector('[data-addon-block]');
        if (currentAddonBlock && !document.getElementById('addon-container')) {
          // Clear the duplicate protection immediately
          window.addonInitialized = false;

          // Store checkbox state before reinitialization
          const wasChecked = localStorage.getItem('addon-checkbox-state') === 'true';

          // Trigger immediate reinitialization
          initializeAddon();

                   // Restore checkbox state immediately
           setTimeout(() => {
             const newCheckbox = document.getElementById('addon-checkbox');
             if (newCheckbox && wasChecked !== null) {
               newCheckbox.checked = wasChecked;
               // Trigger change event to update description
               newCheckbox.dispatchEvent(new Event('change'));
             }
           }, 5); // Instant state restoration

                   // Reset restoring flag quickly
           setTimeout(() => {
             isRestoring = false;
           }, 50); // Faster flag reset
        }
      }, 10); // Ultra-fast restoration
    };

    // Set up mutation observer with debouncing
    const persistenceObserver = new MutationObserver(function(mutations) {
      // Only trigger if addon is actually missing
      if (!document.getElementById('addon-container')) {
        debouncedRestore();
      }
    });

    // Monitor only the product section, not the entire body
    const productSection = addonBlock.closest('[data-section]') ||
                           addonBlock.closest('.featured-product') ||
                           document.body;

    persistenceObserver.observe(productSection, {
      childList: true,
      subtree: true
    });

    // Listen for variant change events with debouncing
    document.addEventListener('variant:change', function() {
      console.log('🔄 Variant change detected - will check addon after variant update completes');
      setTimeout(() => {
        if (!document.getElementById('addon-container')) {
          debouncedRestore();
        }
      }, 50); // Faster variant change response
    });

    // Reduced periodic check - only if really missing
    setInterval(() => {
      if (!document.getElementById('addon-container') && !isRestoring) {
        console.log('⏰ Periodic check - addon missing, restoring');
        debouncedRestore();
      }
    }, 5000); // Increased to 5 seconds to be less aggressive

    console.log('🛡️ Smooth addon persistence system activated - no more reloading effect');

    // Store observer references for cleanup
    window.addonPersistenceObserver = persistenceObserver;
  }

  // Addon system initialized

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeAddon();
      setTimeout(setupAddonPersistence, 100); // Setup persistence immediately after addon creation
    });
    } else {
      initializeAddon();
      setTimeout(setupAddonPersistence, 100); // Setup persistence immediately after addon creation
    }

    })();

  // Global debug function for addon status (outside the IIFE)
  window.debugAddonStatus = function() {
    console.log('🔧 Manual addon status check...');

    const addonBlock = document.querySelector('[data-addon-block]');
    console.log('📍 Addon block element:', addonBlock);

    if (addonBlock) {
      const config = {
        enabled: addonBlock.dataset.addonEnabled === 'true',
        showCheckbox: addonBlock.dataset.showCheckbox !== 'false',
        enableAddonTitle: addonBlock.dataset.enableAddonTitle === 'true',
        addonTitleText: addonBlock.dataset.addonTitleText || '',
        addonTitleStyle: addonBlock.dataset.addonTitleStyle || 'normal',
        addonTitleColor: addonBlock.dataset.addonTitleColor || '',
        variantId: addonBlock.dataset.addonVariantId,
        sellingPlanId: addonBlock.dataset.addonSellingPlanId,
        name: addonBlock.dataset.addonName || 'Product Add-on'
      };
      console.log('⚙️ Current configuration:', config);

      if (!config.enabled) {
        console.log('❌ Issue: Addon is not enabled');
        console.log('💡 Solution: In theme customizer, find the addon block and toggle "Enable Addon" to ON');
      } else if (!config.variantId) {
        console.log('❌ Issue: Missing variant ID');
        console.log('💡 Solution: In theme customizer, set the "Addon Variant ID" field');
      } else if (!config.sellingPlanId) {
        console.log('❌ Issue: Missing selling plan ID');
        console.log('💡 Solution: In theme customizer, set the "Addon Selling Plan ID" field');
      } else {
        console.log('✅ Configuration looks good!');
        console.log('📝 All required settings are present:');
        console.log(`   - Enabled: ${config.enabled}`);
        console.log(`   - Show Checkbox: ${config.showCheckbox}`);
        console.log(`   - Enable Addon Title: ${config.enableAddonTitle}`);
        console.log(`   - Addon Title Text: "${config.addonTitleText}"`);
        console.log(`   - Addon Title Style: ${config.addonTitleStyle}`);
        console.log(`   - Addon Title Color: ${config.addonTitleColor || 'default'}`);
        console.log(`   - Variant ID: ${config.variantId}`);
        console.log(`   - Selling Plan ID: ${config.sellingPlanId}`);
        console.log(`   - Name: ${config.name}`);
      }
    } else {
      console.log('❌ No addon block found on page');
      console.log('💡 Possible causes:');
      console.log('   1. Addon block not added to theme customizer');
      console.log('   2. Addon block disabled in theme customizer');
      console.log('   3. Addon block targeting different product');
      console.log('   4. Current page is not a product page');
      console.log('');
      console.log('🔧 How to fix:');
      console.log('   1. Go to Theme Customizer');
      console.log('   2. Navigate to Product Page settings');
      console.log('   3. Add an "Addon" block');
      console.log('   4. Configure the addon settings');
      console.log('   5. Make sure "Enable Addon" is turned ON');
    }
  };

  // Function to add "Learn More" link to addon description when unchecked
  function addLearnMoreLink() {
    const description = document.getElementById('addon-description');
    if (!description) return;

    // Get the addon block to read custom settings
    const addonBlock = document.querySelector('[data-addon-block]');
    if (!addonBlock) return;

    // Get custom link text from data attribute, fallback to 'Learn More'
    const customLinkText = addonBlock.dataset.learnMoreText || 'Learn More';

    // Remove existing learn more link if present
    const existingLink = description.querySelector('.smartvibes-learn-more-link');
    if (existingLink) {
      existingLink.remove();
    }

    // Create "Learn More" link container
    const learnMoreContainer = document.createElement('div');
    learnMoreContainer.className = 'smartvibes-learn-more-container';
    learnMoreContainer.style.cssText = 'margin-top: 10px;';

    const learnMoreLink = document.createElement('a');
    learnMoreLink.href = '#';
    learnMoreLink.className = 'smartvibes-learn-more-link';
    learnMoreLink.textContent = customLinkText;
    learnMoreLink.style.cssText = 'color: #333; text-decoration: underline; font-size: 14px; cursor: pointer;';
    learnMoreLink.setAttribute('data-smartvibes-learn-more', 'true');

    // Add click handler to open modal
    learnMoreLink.addEventListener('click', (e) => {
      e.preventDefault();
      openSmartVibesModal();
    });

    learnMoreContainer.appendChild(learnMoreLink);
    description.appendChild(learnMoreContainer);
  }

  // Function to open SmartVibes comparison modal
  function openSmartVibesModal() {
    // Get the addon block to read custom settings
    const addonBlock = document.querySelector('[data-addon-block]');

    // Get custom image URL from data attribute, fallback to default SmartVibes image
    const customImageUrl = addonBlock?.dataset.learnMoreImage || 'https://cdn.shopify.com/s/files/1/0267/8341/6517/files/SmartVibes_vs_Basic.png?v=1753897765';

    // Create modal backdrop
    const modalBackdrop = document.createElement('div');
    modalBackdrop.id = 'smartvibes-modal-backdrop';
    modalBackdrop.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      padding: 20px;
      box-sizing: border-box;
    `;

    // Create modal content
    const modalContent = document.createElement('div');
    modalContent.style.cssText = `
      background: white;
      border-radius: 8px;
      max-width: 90vw;
      max-height: 90vh;
      overflow: auto;
      position: relative;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    `;

    // Create close button
    const closeButton = document.createElement('button');
    closeButton.innerHTML = '×';
    closeButton.style.cssText = `
      position: absolute;
      top: 10px;
      right: 15px;
      background: none;
      border: none;
      font-size: 30px;
      cursor: pointer;
      color: white;
      z-index: 1;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: background 0.2s, color 0.2s;
    `;

    // Add hover effect to close button
    closeButton.addEventListener('mouseenter', () => {
      closeButton.style.background = 'black';
      closeButton.style.color = 'white';
    });
    closeButton.addEventListener('mouseleave', () => {
      closeButton.style.background = 'none';
      closeButton.style.color = 'white';
    });

    // Create image
    const image = document.createElement('img');
    image.src = customImageUrl;
    image.alt = 'Learn More Modal Image';
    image.style.cssText = `
      width: 100%;
      height: auto;
      display: block;
      border-radius: 8px;
    `;

    // Add loading state
    image.addEventListener('load', () => {
      image.style.opacity = '1';
    });
    image.style.opacity = '0';
    image.style.transition = 'opacity 0.3s';

    // Assemble modal
    modalContent.appendChild(closeButton);
    modalContent.appendChild(image);
    modalBackdrop.appendChild(modalContent);

    // Add to DOM
    document.body.appendChild(modalBackdrop);

    // Close handlers
    const closeModal = () => {
      modalBackdrop.style.opacity = '0';
      setTimeout(() => {
        if (modalBackdrop.parentNode) {
          modalBackdrop.parentNode.removeChild(modalBackdrop);
        }
      }, 200);
    };

    closeButton.addEventListener('click', closeModal);
    modalBackdrop.addEventListener('click', (e) => {
      if (e.target === modalBackdrop) {
        closeModal();
      }
    });

    // Escape key handler
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', escapeHandler);
      }
    };
    document.addEventListener('keydown', escapeHandler);

    // Fade in effect
    modalBackdrop.style.opacity = '0';
    modalBackdrop.style.transition = 'opacity 0.2s';
    setTimeout(() => {
      modalBackdrop.style.opacity = '1';
    }, 10);

    // Load image with fade in
    setTimeout(() => {
      image.style.opacity = '1';
    }, 100);
  }
